import React from 'react'

class Home extends React.Component {

    teenusedData() {
        return [
            'Raudteede ehitus, remont ja hooldus',
            'Ülesõidukohtade ning pöörangute käsitsi lumest puhastamine',
            'Raudtee ülesõidukohtade ja kergeliikluse ülekäigukohtade ehitamine',
            'Raudtee pealisehitise materjalide müük',
            'Raudtee teemehaanik, tase 4/5 teenused',
            'Raudteede demonteerimine',
            'Raudtee kaitsevööndis üldehitustööd',
            'Kraanateede ehitus-, remondi- ja hooldustööd',
            'Haruraudteede seisundi hindamine',
            'Raudteede ja pöörmete lumest puhastamine raudteeekskavaatoriga',
        ]
    }

    render() {
      return (
          < >
              <div className="paper container margin-bottom-small">
                  <p className="text-lead">Firma tegeleb raudteede ehituse ja remontiga alates 1999.a.</p>
                  <p>
                      Raudteerajatise ehitamine. Raudteede hooldus. Üldehitus.
                  </p>
                  <p>
                      Kehtivad juhtimissüsteemi sertifikaadid vastavalt ISO9001:2015 ja ISO14001:2015 standartidele.
                      {/*<a href="images/juhtimissert.23.1.jpg" className="image-link smashing-link">*/}
                      {/*    <>ISO 9001:2015 sertifikaat </>*/}

                          {/*<img src="./images/juhtimissert.23.tn-sq.jpg"*/}
                          {/*     title="ISO 9001:2015 sertifikaat"*/}
                          {/*     alt="ISO 9001:2015 sertifikaat"*/}
                          {/*     width="100rem" className="shadow "*/}
                          {/*/>*/}
                      {/*</a>*/}
                  </p>
                  <p>
                      Ettevõtte kvaliteedi- ja keskkonnapoliitika juhtpõhimõtted:
                      <ul style={{listStyleType: 'disc', padding: '0 1rem'}}>
                          <li>
                                 Toimime rahvusvahelistele standarditele ISO 9001:2015 ja ISO
                              14001:2015 vastava kvaliteedi- ja keskkonnajuhtimissüsteemi alusel.
                          </li>
                          <li>
                                 Parendame järjepidevalt oma juhtimissüsteemi ja arendame oma
                              tegevusi nii, et tagada klientide rahulolu, keskkonna- ja
                              energiasäästlik tegutsemine ning ettevõtte töötajate tööohutus, võttes
                              arvesse kogemust.
                          </li>
                          <li>
                                 Vähendame oma oluliste keskkonnaaspektide mõjusid keskkonnale läbi
                              ressursside ja materjalide tõhusa kasutamise ning parima võimaliku
                              tehnoloogia kasutamise.
                          </li>
                          <li>
                                 Tagame seadusandlike aktide ja heade tavade järgimise.
                          </li>
                          <li>
                                 Tõstame pidevalt oma teenuste konkurentsivõimet.
                          </li>
                      </ul>
                  </p>

              </div>

              <div className='paper container margin-bottom-small'>
                  <h4>Meie pakutavad teenused:</h4>

                  {
                      this.teenusedData().map((val, index) =>
                          ( <div key={index+1} style={{'line-height': '1.7'}}>{index+1}. {val}</div> )
                      ) }
              </div>


              <div className='paper container margin-bottom-small'>
                  <div className="row flex-top">
                      <div className="col lg-6 md-6 sm-12">
                          <table>
                              <tbody>
                              <tr>
                                  <td>
                                      Aadress: Näituse 26, 50407 Tartu
                                  </td>
                              </tr>
                              <tr>
                                  <td>e-mail: ferrander@gmail.com</td>
                              </tr>
                              </tbody>
                          </table>
                      </div>
                      <div className="col lg-6 md-6 sm-12">
                          <table>
                              <tbody>
                              <tr>
                                  <td>
                                      Reg.nr. 10608381
                                  </td>
                              </tr>
                              <tr>
                                  <td>
                                      KMRK nr. EE100581238
                                  </td>
                              </tr>
                              </tbody>
                          </table>
                      </div>
                  </div>


              </div>
          </>

      )
  }


}

export default Home
